import * as React from 'react';

import { DeviceInfoContext } from '@/contexts/device-info-context';

function InfoIcon(props) {
  const { isMobile } = React.useContext(DeviceInfoContext);

  return isMobile ? (
    <svg width={34} height={34} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M7.377 5.841a5.333 5.333 0 016.465-3.884l14.23 3.548a5.333 5.333 0 013.886 6.465l-3.549 14.231a5.333 5.333 0 01-6.465 3.885l-14.23-3.548a5.333 5.333 0 01-3.885-6.466l3.548-14.23z'
        fill='url(#prefix__paint0_linear_211_1052)'
      />
      <g filter='url(#prefix__filter0_bi_211_1052)'>
        <path
          d='M0 14a5.333 5.333 0 015.333-5.334H20A5.333 5.333 0 0125.333 14v14.666A5.333 5.333 0 0120 34H5.333A5.333 5.333 0 010 28.666V14z'
          fill='#72BF44'
          fillOpacity={0.5}
        />
      </g>
      <path
        d='M12.659 20.463a1.33 1.33 0 00-1.326 1.321v4.244c0 .722.595 1.305 1.326 1.305.731 0 1.341-.583 1.341-1.305v-4.244c0-.72-.61-1.321-1.341-1.321zM14 16.653c0-.718-.61-1.32-1.341-1.32s-1.326.601-1.326 1.337c0 .718.595 1.305 1.326 1.305.731 0 1.341-.6 1.341-1.322z'
        fill='#fff'
        fillOpacity={0.9}
      />
      <defs>
        <linearGradient
          id='prefix__paint0_linear_211_1052'
          x1={8.667}
          y1={0.667}
          x2={30.722}
          y2={3.519}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#4FB84E' />
          <stop offset={1} stopColor='#2A8640' />
        </linearGradient>
        <filter
          id='prefix__filter0_bi_211_1052'
          x={-4}
          y={4.667}
          width={33.333}
          height={33.334}
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity={0} result='BackgroundImageFix' />
          <feGaussianBlur in='BackgroundImageFix' stdDeviation={2} />
          <feComposite in2='SourceAlpha' operator='in' result='effect1_backgroundBlur_211_1052' />
          <feBlend in='SourceGraphic' in2='effect1_backgroundBlur_211_1052' result='shape' />
          <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
          <feOffset dx={0.2} dy={0.1} />
          <feGaussianBlur stdDeviation={0.5} />
          <feComposite in2='hardAlpha' operator='arithmetic' k2={-1} k3={1} />
          <feColorMatrix values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0' />
          <feBlend in2='shape' result='effect2_innerShadow_211_1052' />
        </filter>
      </defs>
    </svg>
  ) : (
    <svg width={50} height={50} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M11.065 7.762a8 8 0 019.697-5.827L42.11 7.258a8 8 0 015.827 9.697l-5.322 21.347a8 8 0 01-9.698 5.827l-21.347-5.322a8 8 0 01-5.827-9.698l5.323-21.347z'
        fill='url(#prefix__paint0_linear_159_180)'
      />
      <g filter='url(#prefix__filter0_bi_159_180)'>
        <path
          d='M0 20a8 8 0 018-8h22a8 8 0 018 8v22a8 8 0 01-8 8H8a8 8 0 01-8-8V20z'
          fill='#72BF44'
          fillOpacity={0.5}
        />
      </g>
      <path
        d='M18.989 29.694A1.996 1.996 0 0017 31.677v6.365c0 1.083.891 1.958 1.989 1.958C20.086 40 21 39.125 21 38.042v-6.365c0-1.08-.914-1.983-2.011-1.983zM21 23.98c0-1.078-.914-1.98-2.011-1.98A2 2 0 0017 24.005c0 1.078.891 1.957 1.989 1.957 1.097 0 2.011-.9 2.011-1.982z'
        fill='#fff'
        fillOpacity={0.9}
      />
      <defs>
        <linearGradient
          id='prefix__paint0_linear_159_180'
          x1={13}
          y1={0}
          x2={46.083}
          y2={4.279}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#4FB84E' />
          <stop offset={1} stopColor='#2A8640' />
        </linearGradient>
        <filter
          id='prefix__filter0_bi_159_180'
          x={-4}
          y={8}
          width={46}
          height={46}
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity={0} result='BackgroundImageFix' />
          <feGaussianBlur in='BackgroundImageFix' stdDeviation={2} />
          <feComposite in2='SourceAlpha' operator='in' result='effect1_backgroundBlur_159_180' />
          <feBlend in='SourceGraphic' in2='effect1_backgroundBlur_159_180' result='shape' />
          <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
          <feOffset dx={0.2} dy={0.1} />
          <feGaussianBlur stdDeviation={0.5} />
          <feComposite in2='hardAlpha' operator='arithmetic' k2={-1} k3={1} />
          <feColorMatrix values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0' />
          <feBlend in2='shape' result='effect2_innerShadow_159_180' />
        </filter>
      </defs>
    </svg>
  );
}

export default InfoIcon;
